/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { GetUserTPromptsQueryResponse, GetUserTPrompts400, GetUserTPrompts401, GetUserTPrompts404, GetUserTPrompts409, GetUserTPrompts500 } from "../../types/GetUserTPrompts.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getGetUserTPromptsUrl() {
  const res = { method: 'GET', url: `/api/me/tprompts` as const }
  return res
}

/**
 * @description Retrieves the list of available TPrompts for the current user.
 * @summary Get user's TPrompts
 * {@link /api/me/tprompts}
 */
export async function getUserTPrompts(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetUserTPromptsQueryResponse, ResponseErrorConfig<GetUserTPrompts400 | GetUserTPrompts401 | GetUserTPrompts404 | GetUserTPrompts409 | GetUserTPrompts500>, unknown>({ method : "GET", url : getGetUserTPromptsUrl().url.toString(), ... requestConfig })
  return res.data
}